import { useQuery } from '@tanstack/react-query';
import { API_GET_TICKETING_BOARDS } from 'constants/appConstants';
import axios from 'constants/axios';
import { useStore } from 'hooks/useStore';
import { getBoardsKeys } from '../queryKeys';
import type { Board } from '../types';

interface BoardsResponse {
  result: Board[];
  error?: {
    code: string;
    description: string;
  };
}

interface UseGetBoardsProps {
  enabled?: boolean;
  onSuccess?: (data: BoardsResponse) => void;
  onError?: (error: unknown) => void;
}

const API_GET_BOARDS = async ({ onSuccess, onError }: UseGetBoardsProps) => {
  try {
    const response = await axios.get<BoardsResponse>(
      `${API_GET_TICKETING_BOARDS}`
    );

    if (response.data?.error) {
      throw new Error(String(response.data.error.description));
    }

    onSuccess?.(response.data);

    return response.data;
  } catch (error) {
    onError?.(error);

    throw error;
  }
};

export const useGetBoardsQuery = ({
  enabled = true,
  onSuccess,
  onError,
}: UseGetBoardsProps) => {
  const addNotificationError = useStore(
    (state) => state.notificationSlice.addNotificationError
  );

  return useQuery({
    enabled,
    queryKey: getBoardsKeys,
    queryFn: () =>
      API_GET_BOARDS({
        onSuccess,
        onError: (error) => {
          if (!onError) {
            addNotificationError({
              message: String(error),
            });
          }

          onError?.(error);
        },
      }),
    retry: false,
  });
};
